import $ from 'jquery';

// Handle Collapsing all of an accordion
$('[id^=ncst-accordion-collapse]').on('click', function () {
    let accordionCollapseBtn = $(this);
    accordionCollapseBtn.addClass('active');
    let accordionExpandBtn = $(this).parent().children(".expand-all");
    accordionExpandBtn.removeClass('active');
    let accordionParent = $(this).parent().parent();
    let isLinked = accordionParent.hasClass("isLinked");
    let accordionParentID = accordionParent.attr('id').split('-')[2];
    console.log(accordionParentID)
    let accordionItemHeaders = accordionParent.find(".wp-block-ncst-accordion-item");
    accordionItemHeaders.each(function() {
      if(isLinked){
        $(this).attr("name", accordionParentID);
      }
      $(this).attr("open", false);
      $(this).attr("aria-expanded", "false");
    });
});

// Handle Expanding all of an accordion
$('[id^=ncst-accordion-expand]').on('click', function () {
  let accordionCollapseBtn = $(this).parent().children(".collapse-all");
  accordionCollapseBtn.removeClass('active');
  let accordionExpandBtn = $(this);
  accordionExpandBtn.addClass('active');
  let accordionParent = $(this).parent().parent();
  let accordionItemHeaders = accordionParent.find(".wp-block-ncst-accordion-item");
  accordionItemHeaders.each(function() {
    $(this).attr("name", "");
    $(this).attr("open", true);
    $(this).attr("aria-expanded", "true");
  });
});

$('.accordion-item__header').on('click', function() {
  let accordionParent = $(this).parent().parent();
  let accordionCollapseBtn = accordionParent.find('.collapse-all');
  accordionCollapseBtn.removeClass('active');
  let accordionExpandBtn = accordionParent.find('.expand-all');
  accordionExpandBtn.removeClass('active');
});
